import { isArray } from 'util';

let girlIdx = 0;
let spineIdx = 0;
const DESCRIPTION_LENGTH = 40;

export function deselectIsSelectedProp(items) {
    return items.childNodes.map((item) => {
        item.isSelected = false;
        if (item.childNodes.length > 0) {
            deselectIsSelectedProp(item);
        }
        return undefined;
    });
}

export function findNode(id, items) {
    if (items) {
        const nodes = items.childNodes || items;
        return nodes.find(d => d.id === id) || findNode(id, nodes.flatMap(d => d.childNodes || []))
            || undefined;
    }

    return undefined;
}

export default function updateTreeSelection(id, topicTree, selectedTopic) {
    let topicId = '';
    let topicNode = {};
    if (id.indexOf('#') !== -1) {
        const filteredTopics = topicTree.childNodes.find(item => item.id === id.split('#')[id.split('#').length - 1]);
        if (id === selectedTopic) {
            topicNode = findNode(id, filteredTopics);
            if (topicNode) {
                topicNode.isSelected = false;
            }
        } else {
            deselectIsSelectedProp(topicTree);
            topicNode = findNode(id, filteredTopics);
            if (topicNode) {
                topicNode.isSelected = true;
                topicId = id;
            }
        }
    } else if (id.indexOf('#') === -1 && id === selectedTopic) {
        topicNode = topicTree.childNodes.find(t => t.id === id);
        if (topicNode) {
            topicNode.isSelected = false;
        }
    } else {
        deselectIsSelectedProp(topicTree);
        topicNode = topicTree.childNodes.find(t => t.id === id);
        if (topicNode) {
            topicNode.isSelected = true;
            topicId = id;
        }
    }

    return topicId;
}

export function updateIndexes(id, topics) {
    let parentId = 0;
    let spineId = 0;
    let subTopic = {};
    let items = topics.childNodes;

    if (id.indexOf('#') !== -1 || id.indexOf('-') !== -1) {
        if (id.toLowerCase().indexOf('girl') !== -1) {
            parentId = id.split('-')[0];
            spineId = id.split('-')[2];
            const spine = findNode(`${parentId}-${spineId}-spine`, topics.childNodes);
            items = spine.childNodes;
        } else if (id.indexOf('-') !== -1) {
            parentId = id.split('-')[0];
            subTopic = findNode(parentId, topics.childNodes);
            items = subTopic.childNodes;
        } else {
            parentId = id.substring(id.indexOf('#') + 1);
            subTopic = findNode(parentId, topics.childNodes);
            items = subTopic.childNodes;
        }
    }

    items.map((item, index) => {
        item.index = index;
        return item;
    });

    return topics;
}


function updateIsExpandedProp(id, items, status, spineId) {
    const topic = items.childNodes.find(item => item.id === id.split('#')[id.split('#').length - 1]);
    const node = findNode(spineId || id, topic);
    node.isExpanded = status;
}

export function nodeExpandCollapse(id, status, topics) {
    if (id.indexOf('spine') !== -1) {
        if (id.indexOf('#') !== -1) {
            const stParentId = id.split('-')[0];
            updateIsExpandedProp(stParentId, topics, status, id);
        } else {
            const topic = topics.childNodes.find(item => item.id === id.split('-')[0]);
            const node = findNode(id, topic);
            node.isExpanded = status;
        }
    } else if (id.indexOf('#') !== -1) {
        updateIsExpandedProp(id, topics, status);
    } else {
        const topic = topics.childNodes.find(t => t.id === id);
        topic.isExpanded = status;
    }
    return topics;
}

function deleteTreeNodes(id, items) {
    return items.map((item, index) => {
        if (id === item.id) {
            items.splice(index, 1);
            return item;
        } else if (item.childNodes.length > 0) {
            return deleteTreeNodes(id, item.childNodes);
        }
        return null;
    });
}

export function findSpineNode(items, spineIds) {
    for (const item of items.childNodes) {
        if (item.id.indexOf('spine') !== -1) {
            spineIds.push(item.id.split('-')[1]);
        }

        if (item.childNodes.length > 0) {
            findSpineNode(item, spineIds);
        }
    }
}

export function deleteNode(id, topics) {
    const matchItem = findNode(id, topics);
    deleteTreeNodes(id, topics.childNodes);
    return matchItem;
}

function getGirlResources(items) {
    const girls = [];
    if (items.length > 0) {
        const includedGirls = items.filter(item => item.isIncluded);
        for (const girl of includedGirls) {
            girls.push(girl.id.split('-')[1]);
        }
    }
    return girls;
}

function buildSubTopics(node, parentNode) {
    for (const val of node.childNodes) {
        const subItem = {};
        subItem.name = val.name;
        subItem.type = val.type;
        subItem.strand = val.strand;
        subItem.subStrand = val.subStrand;
        subItem.description = val.description;
        subItem.externalKey = val.externalKey;
        subItem.curriculumLevelCode = val.curriculumLevelCode;
        subItem.childTopics = [];
        subItem.spineNodes = [];
        if (val.id.indexOf('-') !== -1) {
            parentNode.spineNodes.push({
                id: val.id.split('-')[1],
                girlIds: parentNode.type.toLowerCase() === 'step' ? [] : getGirlResources(val.childNodes)
            });
        } else if (val.childNodes.length > 0) {
            parentNode.childTopics.push(buildSubTopics(val, subItem));
        } else {
            parentNode.childTopics.push(subItem);
        }
    }
    return parentNode;
}

function getChildTopics(node, parentNode) {
    const item = {};
    item.name = node.name;
    item.childTopics = [];
    item.spineNodes = [];
    item.type = node.type;
    item.strand = node.strand;
    item.subStrand = node.subStrand;
    item.description = node.description;
    item.externalKey = node.externalKey;
    item.curriculumLevelCode = node.curriculumLevelCode;

    parentNode.childTopics.push(buildSubTopics(node, item));
    return parentNode;
}

export function buildTopicObject(topicTree) {
    const topics = topicTree.childNodes.map((val) => {
        const course = {};
        course.name = val.name;
        course.type = val.type;
        course.strand = val.strand;
        course.subStrand = val.subStrand;
        course.description = val.description;
        course.externalKey = val.externalKey;
        course.curriculumLevelCode = val.curriculumLevelCode;
        course.childTopics = [];
        course.spineNodes = [];
        for (const node of val.childNodes) {
            if (node.id.indexOf('#') === -1) {
                course.spineNodes.push({
                    id: node.id.split('-')[1],
                    girlIds: getGirlResources(node.childNodes)
                });
            } else {
                getChildTopics(node, course);
            }
        }
        return course;
    });

    return topics;
}

function getSpineGirls(spine) {
    return spine.girls.map((girl, idx) => {
        girl.name = `${girl.id}-${girl.teacherTitle}`;
        girl.id = `${spine.id.split('-')[0]}-${girl.id}-${spine.id.split('-')[1]}`;
        girl.index = idx;
        girl.groupName = `girl${girlIdx}`;
        girl.groupType = `girl${girlIdx}`;
        girl.childNodes = [];
        girl.isEditable = false;
        girl.isIncluded = girl.isEnabled;
        girl.previewUrl = girl.previewUrl;
        return girl;
    });
}

function getSpineNodes(topic, isSubTopic, spineIndex, parentNode) {
    let index = 0;
    for (const spine of topic.spineNodes) {
        spine.name = `${spine.id}: ${spine.description}`;
        spine.id = `${parentNode.id}-${spine.id}-spine`;
        spine.index = index;
        spine.groupName = isSubTopic ? `subTopic${spineIndex}` : `spine${parentNode.spineIndex}`;
        spine.groupType = isSubTopic ? `subTopic${spineIndex}` : `spine${parentNode.spineIndex}`;
        spine.girlIndex = girlIdx;
        spine.isExpanded = false;
        spine.childNodes = getSpineGirls(spine);
        girlIdx += 1;
        index += 1;
        spine.isEditable = false;
        parentNode.childNodes.push(spine);
    }

    return parentNode;
}

function getSubTopics(node, startIndex, parentNode) {
    for (const val of node.childTopics) {
        const item = {};
        spineIdx += 1;
        item.name = val.name;
        item.id = `${val.id.toString()}#${parentNode.id}`;
        item.index = startIndex;
        item.groupName = `spine${parentNode.spineIndex}`;
        item.groupType = `spine${parentNode.spineIndex}`;
        item.isEditable = true;
        item.isExpanded = false;
        item.isSelected = false;
        item.spineIndex = spineIdx;
        item.externalKey = val.externalKey;
        item.type = val.type;
        item.description = val.description;
        item.strand = val.strand;
        item.subStrand = val.subStrand;
        item.childNodes = [];
        item.curriculumLevelCode = val.curriculumLevelCode;
        if (val.spineNodes.length > 0) {
            getSpineNodes(val, true, spineIdx, item);
        }
        if (val.childTopics.length > 0) {
            getSubTopics(val, item.childNodes.length, item);
        }
        startIndex += 1;
        parentNode.childNodes.push(item);
    }

    return parentNode;
}

export function getCourseTopics(topics, girlIndex, spineIndex) {
    girlIdx = girlIndex;
    spineIdx = spineIndex;
    let topicId = 0;
    const childNodes = topics.map((topic, topicIndex) => {
        const course = {};
        topicId = topic.id;
        course.id = topic.id.toString();
        course.name = topic.name;
        course.childNodes = [];
        course.index = topicIndex;
        course.groupName = 'topicList';
        course.groupType = 'topic';
        course.isEditable = true;
        course.isSelected = false;
        course.spineIndex = spineIdx;
        course.isExpanded = true;
        course.externalKey = topic.externalKey;
        course.type = topic.type;
        course.description = topic.description;
        course.strand = topic.strand;
        course.subStrand = topic.subStrand;
        course.curriculumLevelCode = topic.curriculumLevelCode;
        course.childNodes = [];
        if (topic.spineNodes.length > 0) {
            getSpineNodes(topic, false, spineIdx, course);
        }
        if (topic.childTopics.length > 0) {
            getSubTopics(topic, course.childNodes.length, course);
        }
        spineIdx += 1;
        return course;
    });

    return { childNodes, girlIdx, spineIdx, topicId };
}

export function onToggle(id, status, topics) {
    const node = findNode(id, topics);
    node.isIncluded = status;
    return topics;
}


export function handleOnExpandCollapse(status, topicTree) {
    if (topicTree.childNodes.length > 0) {
        topicTree.childNodes = topicTree.childNodes.map((topic) => {
            topic.isExpanded = status;
            topic.childNodes.map((spine) => {
                spine.isExpanded = status;
                if (spine.id.indexOf('#') !== -1) {
                    spine.childNodes.map((val) => {
                        val.isExpanded = status;
                        return val;
                    });
                }
                return spine;
            });
            return topic;
        });
    }
    return topicTree;
}

export function updateTopicName(response, topics) {
    if (response.id.indexOf('#') !== -1) {
        const subTopic = findNode(response.id, topics);
        subTopic.name = response.name;
        subTopic.strand = response.strand;
        subTopic.subStrand = response.subStrand;
        subTopic.externalKey = response.externalKey;
        subTopic.description = response.description;
        subTopic.curriculumLevelCode = response.curriculumLevelCode;
    } else {
        const topic = topics.childNodes.find(item => item.id === response.id);
        topic.name = response.name;
        topic.strand = response.strand;
        topic.subStrand = response.subStrand;
        topic.externalKey = response.externalKey;
        topic.description = response.description;
        topic.curriculumLevelCode = response.curriculumLevelCode;
    }
    return topics;
}

export function getStrandSubstrand(id, topics) {
    let standInfo = {
        name: '',
        strand: 'None',
        subStrand: 'None',
        externalKey: '',
        description: '',
        curriculumLevelCode: '',
        topicType: ''
    };
    if (id) {
        if (id.indexOf('#') !== -1) {
            const subTopic = findNode(id, topics);
            standInfo = {
                name: subTopic.name,
                strand: subTopic.strand,
                subStrand: subTopic.subStrand,
                externalKey: subTopic.externalKey,
                description: subTopic.description,
                curriculumLevelCode: subTopic.curriculumLevelCode,
                type: subTopic.type
            };
        } else {
            const topic = topics.childNodes.find(item => item.id === id);
            standInfo = {
                name: topic.name,
                strand: topic.strand,
                subStrand: topic.subStrand,
                externalKey: topic.externalKey,
                description: topic.description,
                curriculumLevelCode: topic.curriculumLevelCode,
                type: topic.type
            };
        }
    }
    return standInfo;
}

export function trimStringWithEllipsis(string = '', length = DESCRIPTION_LENGTH) {
    return string.length > length ?
        `${string.substring(0, length)}...` : string;
}

export function getCurriculumDescriptions(response) {
    if (isArray(response) && response.length) {
        const curriculumDescriptions = response.map((item) => {
            const { code = '', id = '', description = '' } = item;
            const label = trimStringWithEllipsis(description, DESCRIPTION_LENGTH);
            return { label, code, value: description, id };
        });
        return curriculumDescriptions;
    } return null;
}

export function filterSpineOnStrandSubStrand(topic = '', spineList = []) {
    if (topic && topic.strand) {
        if (isArray(spineList) && spineList.length) {
            return spineList.filter((item) => {
                const pattern = new RegExp(`^${topic.strand.toLowerCase()}.*$`);
                const subStrand = topic && topic.subStrand.toLowerCase();
                const id = item && item.id.toLowerCase();
                if (subStrand && subStrand.toLowerCase() !== 'none') {
                    if (pattern.test(id) && (id.indexOf(subStrand) !== -1)) return item;
                } else if (pattern.test(id)) return item;
                return null;
            }
            );
        }
    }
    return spineList;
}



// WEBPACK FOOTER //
// ./app/helpers/course-creator-utils.js